const ja = {
  nav: {
    home: "ホーム",
    about: "私たちについて",
    destinations: "目的地",
    tours: "ツアー＆パッケージ",
    gallery: "ギャラリー",
    testimonials: "お客様の声",
    blog: "ブログ",
    contact: "お問い合わせ",
    experiences: "体験",
    vip: "VIPビジネス",
    vipFull: "VIPビジネス旅行",
    worldcup: "2030年ワールドカップ",
    jewishHeritage: "コーシャ旅行",
    menu: "メニュー",
    chatWhatsApp: "WhatsAppでチャット"
  },
  hero: {
    welcome: "モロッコへようこそ。",
    welcomeHome: "おかえりなさい。",
    subtitle: "プライベートな豪華ツアー、本物の体験、",
    subtitleLine2: "そしてモロッコ全土での完全なパーソナルサービス —",
    subtitleGold: "CEOが直接対応いたします。",
    whatsappBtn: "WhatsAppでIlan（CEO）とチャットする",
    badgeFast: "迅速な対応",
    badgePersonal: "パーソナルサービス",
    badge247: "24時間対応",
    limitedAvail: "空き枠わずか",
    personalizedOnly: "オーダーメイド旅行のみ"
  },
  strip: {
    privateTours: "プライベートツアー",
    localExperts: "現地の専門家",
    bestHotels: "最高のホテル",
    luxuryTransport: "豪華な交通手段",
    satisfaction: "満足度100%"
  },
  cta: {
    whatsapp: "WhatsAppでIlan（CEO）とチャットする",
    whatsappFloating: "WhatsAppでチャット",
    whatsappInquiry: "こんにちは、モロッコでのプレミアムな旅行体験に興味があります。"
  },
  home: {
    vipBannerTitle: "VIPモロッコ旅行体験",
    vipBannerText: "目の肥えた旅行者のための専用アクセス、専属運転手、高級宿泊施設。",
    vipBannerBtn: "VIPサービスを見る",
    wcBadge: "🇲🇦 2030年モロッコワールドカップ",
    wcTitle: "モロッコ 2030",
    wcText: "サッカー、モロッコ文化、VIPのホスピタリティ、そして豪華な体験を組み合わせた限定のワールドカップ旅行パッケージ。",
    wcBtn: "パッケージを見る",
    galleryTitle: "ギャラリー",
    gallerySubtitle: "あなたの未来のモロッコ旅行を覗いてみましょう",
    exploreDestination: "目的地を探索する",
    featuredToursTitle: "おすすめのツアーとパッケージ",
    featuredToursSubtitle: "完璧なモロッコ冒険のために厳選された体験",
    viewAllTours: "すべてのツアーを見る",
    culinaryTitle: "私たちの料理 - 世界一",
    culinarySubtitle: "モロッコの卓越した食文化を体験してください 🍲",
    culinaryBtn: "料理体験を見る",
    culinaryIntro: "Morocco Loves Youでは、食事は単なる食事ではありません。それはモロッコ文化の核心への旅です。私たちは、伝統的な家庭料理から高級なモロッコ料理まで、愛を込めて、最も新鮮な地元の食材で調理された、本物の厳選された食体験を提供します。",
    videoTitle: "おすすめ",
    unityQuote: "Morocco Loves Youは、すべての文化、すべての信仰、すべての人々を歓迎します。",
    unityAlt: "Morocco Loves You 団結バナー",
    testimonialsTitle: "VIPゲストの声",
    testimonialsSubtitle: "世界中の旅行者からの本物のレビュー",
    readMoreReviews: "さらにレビューを読む",
    viewAllTransport: "すべての交通手段を表示",
    transportTitle: "VIP向け交通サービスとドライバー",
    transportSubtitle: "モロッコ全土でのラグジュアリー、快適さ、そして安全性 🌍",
    transportIntro: "Morocco Loves Youでは、交通は単なる移動手段ではありません。それは体験の一部です。私たちはモロッコ全土で、プロのドライバー、温かいおもてなし、そして最初から最後までVIPサービスを提供し、清潔で快適な最新のエアコン完備の車両を提供しています。"
  },
  tours: {
    pageTitle: "ツアーとパッケージ",
    pageSubtitle: "厳選されたモロッコツアーパッケージからお選びください",
    sectionTitle: "ツアーパッケージ",
    sectionIntro: "砂漠の冒険から海辺の逃避行まで、すべての旅行者にぴったりのパッケージをご用意しています",
    howToBook: "予約方法",
    step1Title: "ツアーを選ぶ",
    step1Text: "パッケージを閲覧し、あなたに最適なものを選んでください",
    step2Title: "「今すぐ予約」をクリック",
    step2Text: "選んだツアーの「今すぐ予約」ボタンをクリックしてください",
    step3Title: "詳細を入力",
    step3Text: "旅行の日程と個人情報を提供してください",
    step4Title: "確認",
    step4Text: "メールで確認と旅程の詳細を受け取ります",
    customTitle: "カスタマイズされたパッケージが必要ですか？",
    customText: "パーソナライズされたモロッコツアー体験を作成するにはお問い合わせください",
    customBtn: "お問い合わせ",
    days: "日間",
    highlights: "ハイライト:",
    bookNow: "今すぐ予約",
    highlightsLabel: "ハイライト:",
    viewFullDetails: "詳細を見る",
    premiumPackage: "プレミアムパッケージ",
    arrival: "到着:",
    route: "ルート:",
    flights: "フライト:",
    transportation: "交通:",
    hotels: "ホテル:",
    foodDining: "食事:",
    whatsIncluded: "含まれるもの:",
    attractionsExperiences: "観光・体験:",
    itinerary: "旅程:",
    optionalExperiences: "オプション体験:",
    availableUponRequest: "リクエストに応じて手配可能:",
    specialSaharaExperience: "特別なサハラ体験:",
    suitableFor: "おすすめ対象:",
    importantNotes: "重要事項:",
    priceInformation: "料金について:",
    priceWarningText: "料金は航空券価格、為替レート、祝日、シーズン、ホテルの空き状況により変動する場合があります。",
    safetyComfort: "安全と快適さ:",
    safetyText: "お客様の安全と快適さを確保するため、モロッコ当局および警備サービスと連携しています。",
    givesMore: "Morocco Loves You はさらに多くを提供します:",
    givesMoreText: "より多くの愛、心配り、プロ意識、喜び、安全を。人の温かさを感じる、安心でリラックスしたツアーです。",
    bookThisPackage: "このパッケージを予約",
    backToPackages: "パッケージに戻る",
    premiumMoroccoPackages: "プレミアム・モロッコパッケージ",
    premiumMoroccoPackagesDesc: "こだわりのお客様のために厳選した特別な体験です。",
    pkg1: {
      title: "ヨーロッパ/モロッコ ラグジュアリー週末旅行",
      duration: "3泊 / 4日",
      price: "€790",
      hl1: "直行往復航空券込み（ロンドン/ヨーロッパ）",
      hl2: "4〜5つ星の高級ホテル",
      hl3: "伝統的なモロッコ式ハマム",
      hl4: "料理とアートのワークショップ",
      hl5: "モロッコのライブパフォーマンス",
      subtitle: "オールインクルーシブパッケージ - AからZまで",
      flight1: "直行往復航空券",
      flight2: "20kgの受託手荷物",
      flight3: "8kgまでの機内持ち込み手荷物",
      inc1: "空港送迎（往復）",
      inc2: "4〜5つ星ホテル（ハーフボード）",
      inc3: "新鮮で本格的なモロッコ料理",
      inc4: "伝統的なお茶と菓子の体験",
      inc5: "プロのツアーガイドと専用ドライバー",
      inc6: "最新のエアコン付き交通機関",
      inc7: "特別ライブパフォーマンス（歌手・ダンサー）",
      inc8: "伝統市場ツアー（スパイス、ランタン、カーペット）",
      inc9: "料理とアートのワークショップ（事前予約制）",
      inc10: "天然の泉と展望スポット訪問",
      inc11: "シャウエンとイフレンへの日帰り旅行",
      inc12: "地元モロッコ家庭の訪問",
      inc13: "ツアー中のサプライズ体験",
      suit1: "カップル",
      suit2: "家族",
      suit3: "グループ",
      suit4: "一人旅",
      suit5: "シニア",
      suit6: "企業",
      suit7: "旅行代理店",
      suit8: "ツアーオペレーター"
    },
    pkg2: {
      title: "モロッコ・ラグジュアリー発見ツアー",
      duration: "6泊 / 7日",
      price: "€1490",
      hl1: "パッケージA",
      hl2: "アトラスの旅",
      hl3: "マラケシュ - エッサウィラ - メルズーガ - ワルザザート - マラケシュ",
      hl4: "大きなサプライズ ❤️",
      hl5: "パッケージB",
      subtitle: "フェズと北モロッコルート（オールインクルーシブ）",
      routeText: "フェズ2泊、シャウエン1泊、タンジェ1泊、イフレン1泊、最終夜フェズ1泊",
      flight1: "ヨーロッパからの直行往復航空券",
      flight2: "20kg手荷物 + 機内持ち込み手荷物",
      trans1: "空港送迎",
      trans2: "専用プロドライバーとツアーガイド",
      trans3: "新しいエアコン付き車両",
      hotel1: "4〜5つ星ホテル",
      hotel2: "便利で上質なロケーション",
      hotel3: "高水準のサービス",
      food1: "ハーフボード",
      food2: "本格料理",
      food3: "伝統的なお茶と菓子",
      exp1: "モロッコのライブパフォーマンス",
      exp2: "伝統市場（スパイス、ランタン、カーペット）",
      exp3: "伝統的なモロッコ式ハマム",
      exp4: "自然と森の訪問",
      exp5: "美しい展望スポットと日帰り旅行",
      exp6: "料理とアートのワークショップ",
      exp7: "地元家庭の訪問",
      exp8: "旅行中の特別なサプライズ",
      suit1: "カップル",
      suit2: "家族",
      suit3: "グループ",
      suit4: "一人旅",
      suit5: "シニア",
      suit6: "企業",
      suit7: "旅行代理店"
    },
    pkg3: {
      title: "モロッコ・グランド体験",
      duration: "10泊 / 11日",
      price: "€1990",
      hl1: "プレミアム地上サービス一式",
      hl2: "カサブランカ、マラケシュ、フェズ",
      hl3: "アガディールとサハラ砂漠のサプライズ",
      hl4: "ワルザザートとシャウエンを訪問",
      hl5: "特別なライブ音楽とパフォーマンス",
      subtitle: "✨ モロッコ・グランド体験（地上サービスのみ）",
      arrivalText: "カサブランカまたはマラケシュ",
      routeText: "カサブランカ、ラバト、フェズ2泊、タンジェ、シャウエン、イフレン、マラケシュ2泊、アガディール、ワルザザート、最終夜マラケシュ",
      note2: "40名以上のグループ: お一人様$50の特別割引",
      note3: "国際線航空券と保険は含まれません",
      note4: "ドライバー/ガイドへのチップは含まれません",
      inc1: "プレミアム地上サービス一式",
      inc2: "4〜5つ星ホテル（ハーフボード）",
      inc3: "プロのツアーガイドと専用ドライバー",
      inc4: "エアコン付きバスまたはミニバス",
      inc5: "ライブパフォーマンスと音楽の雰囲気",
      inc6: "伝統市場とハマム訪問",
      inc7: "料理とアートのワークショップ",
      inc8: "森、泉、展望スポットへの小旅行",
      inc9: "地元家庭の訪問",
      inc10: "旅の途中の特別なサプライズ"
    },
    pkg4: {
      title: "ラグジュアリー・モロッコ体験",
      duration: "16泊 / 17日",
      price: "オールインクルーシブ",
      hl1: "カサブランカ • ラバト • フェズ • タンジェ • シャウエン",
      hl2: "イフレン • メルズーガ・サハラ砂漠",
      hl3: "エッサウィラ • ウリカとアトラス山脈 • マラケシュ",
      hl4: "ラクダとジープツアー付き高級砂漠キャンプ2泊",
      hl5: "幻想的な朝日と夕日 • 星空の下で眠る",
      subtitle: "✨ モロッコ帝国都市とサハラ体験 - 完全な旅（16泊 / 17日）",
      routeText: "カサブランカ（1泊）、ラバト、フェズ（2泊）、タンジェ（1泊）、シャウエン（1泊）、イフレン（1泊）、メルズーガ・サハラ（2泊）、エッサウィラ（2泊）、ウリカとアトラス山脈（1泊）、マラケシュ（3泊）",
      itinerary1: "カサブランカ - 到着（1泊）",
      itinerary2: "ラバト - 王都",
      itinerary3: "フェズ - 精神と文化のモロッコ（2泊）",
      itinerary4: "タンジェ - ヨーロッパとアフリカが出会う街（1泊）",
      itinerary5: "シャウエン - 青い真珠（1泊）",
      itinerary6: "イフレン - モロッコのスイス（1泊）",
      itinerary7: "メルズーガ・サハラ砂漠（2泊） - 高級砂漠キャンプ - ラクダ体験 - ジープツアー - 幻想的な朝日と夕日 - 星空の下で宿泊",
      itinerary8: "エッサウィラ - 大西洋の街で過ごす時間（2泊）",
      itinerary9: "ウリカとアトラス山脈（1泊）",
      itinerary10: "マラケシュ - 赤い街（3泊）",
      inc1: "4★ / 5★ ホテル",
      inc2: "高級エアコン付き砂漠キャンプ",
      inc3: "フルボード / プレミアム・モロッコ料理",
      inc4: "プロの多言語ガイド",
      inc5: "専用の近代的な交通機関",
      inc6: "エアコン付き大型バス",
      inc7: "車内WiFi • TV • 冷蔵庫",
      inc8: "ツアー中の専用ドライバー",
      inc9: "ラクダツアー",
      inc10: "ジープ砂漠体験",
      inc11: "フォークロアショーとライブ音楽",
      inc12: "モロッコ舞踊パフォーマンス",
      inc13: "料理ワークショップ",
      inc14: "市場とスーク体験",
      inc15: "カーペット • スパイス • 花 • 伝統工芸",
      inc16: "湖 • 川 • アトラス山脈",
      inc17: "特別な朝日と夕日の体験",
      inc18: "24時間年中無休の直接サポート",
      optional1: "熱気球体験",
      optional2: "VIPアップグレード",
      optional3: "ラグジュアリー体験",
      optional4: "プライベートセキュリティサービス",
      optional5: "医療サポートサービス",
      optionalNote: "一部のプレミアムサービスには、適正な追加料金が必要な場合があります。"
    }
  },
  destinations: {
    pageTitle: "モロッコの目的地を探索",
    pageSubtitle: "美しいモロッコ中の素晴らしい場所を発見してください",
    sectionTitle: "すべての目的地",
    sectionIntro: "モロッコは多様な風景と豊かな文化遺産を持つ国です。厳選された目的地を探索してください：",
    exploreNow: "今すぐ探索",
    ctaTitle: "旅行の計画を立てる準備はできましたか？",
    ctaText: "厳選されたツアーとパッケージを閲覧して、完璧なモロッコ体験を見つけてください",
    ctaBtn: "ツアーとパッケージを見る"
  },
  experiences: {
    pageTitle: "モロッコ料理の素晴らしさ",
    pageSubtitle: "世界で最も美味しい料理を発見してください",
    bookViaWhatsApp: "WhatsAppで予約"
  },
  vip: {
    pageTitle: "VIP＆ビジネス旅行",
    pageSubtitle: "CEO、投資家、目の肥えた旅行者のための特別なサービス",
    introTitle: "モロッコでの完璧なエクセレンス",
    introText: "MoroccoLovesYouは、出張者、企業代表団、VIPゲストに比類のない基準のサービスを提供します。到着から出発まで、すべての細部を正確に処理します。",
    ctaTitle: "CEOへの直接アクセス",
    ctaText: "緊急の問い合わせや高度に専門化されたリクエストについては、創業者兼CEOのIlan Hatchuelと直接お話しください。",
    ctaBtn: "Ilanに連絡する",
    luxuryTransport: "豪華な交通手段",
    luxuryTransportDesc: "VIP空港送迎と高級車（メルセデスSクラス、Vクラス）によるバイリンガル専用運転手が24時間利用可能です。",
    premiumAccom: "プレミアムな宿泊施設",
    premiumAccomDesc: "エグゼクティブに適した5つ星ホテル、高級リアド、またはプライベートヴィラの特別予約。",
    businessConcierge: "ビジネスコンシェルジュ",
    businessConciergeDesc: "会議の全面的なサポート、プライベートダイニングの予約、企業の研修旅行向けの特別な旅程。",
    securityPrivacy: "セキュリティとプライバシー",
    securityPrivacyDesc: "著名人のための慎重なサービス、安全な環境、絶対的な機密保持。",
    support247: "24時間サポート",
    support247Desc: "CEOとの直接連絡と、滞在中にいつでもサポートできる専任チーム。",
    customItineraries: "カスタムの旅程",
    customItinerariesDesc: "ビジネスの義務とプレミアムなモロッコ文化体験の完璧なバランスをとるカスタマイズされた旅行計画。"
  },
  worldcup: {
    pageTitle: "モロッコ 2030 ワールドカップ",
    pageSubtitle: "最大のサッカーイベントのための独占的なVIPパッケージ",
    limitedBadge: "空き枠わずか",
    introTitle: "究極のサッカーの旅",
    introText: "2030年、モロッコはFIFAワールドカップを共同開催します。私たちは快適さとアクセスにおいて最高を求めるファンのために設計された独占的な高級旅行パッケージを提供できることを誇りに思います。",
    packagesTitle: "プレミアムワールドカップパッケージ",
    silverTitle: "シルバーパッケージ",
    silverSub: "必須の体験",
    goldTitle: "ゴールドパッケージ",
    goldSub: "豪華な体験",
    mostPopular: "一番人気",
    diamondTitle: "ダイヤモンドVIP",
    diamondSub: "究極の体験",
    inquireWhatsApp: "WhatsAppで問い合わせ",
    ctaTitle: "価格が上がる前に席を確保する",
    ctaText: "国際的な需要が非常に高いため、VIPパッケージを早めに確保することを強くお勧めします。",
    ctaBtn: "今日お問い合わせ",
    silverF1: "プレミアムリアド / 4つ星ホテル",
    silverF2: "試合日の事前計画されたロジスティクス",
    silverF3: "ガイド付き市内ツアー（開催都市）",
    silverF4: "24時間対応の専用サポートライン",
    goldF1: "5つ星ホテル / 高級ヴィラ",
    goldF2: "専用の空港と試合の送迎",
    goldF3: "VIP砂漠キャンプ（2日間）",
    goldF4: "バイリンガルのパーソナルコンシェルジュ",
    diamondF1: "プレジデンシャルスイート / プライベートパレス",
    diamondF2: "24時間体制の専用運転手とセキュリティ",
    diamondF3: "VIPイベントへの独占アクセス",
    diamondF4: "CEOの直接対応とVVIPコンシェルジュ"
  },
  gallery: {
    pageTitle: "ギャラリー",
    pageSubtitle: "忘れられないモロッコの旅の視覚的な記憶",
    picturesTitle: "写真で見るモロッコ",
    picturesIntro: "息を呑むようなモロッコの写真コレクションをご覧ください",
    videosTitle: "動画で見るモロッコ",
    videosIntro: "厳選された動画コレクションを通じてモロッコを体験してください"
  },
  testimonials: {
    pageTitle: "ゲストの声",
    pageSubtitle: "旅行者がモロッコでの体験について語った内容をお読みください",
    sectionTitle: "幸せな旅行者たち",
    sectionIntro: "何千人もの満足したゲストが私たちと一緒にモロッコの魔法を体験しました",
    verifiedGuest: "確認済みのゲスト",
    ratingsTitle: "評価",
    avgRating: "平均評価",
    verifiedReviews: "確認済みのレビュー",
    fromReal: "実際の旅行者から",
    custSatisfaction: "顧客満足度",
    wouldRecommend: "おすすめします",
    shareTitle: "体験を共有する",
    shareText: "素晴らしい旅行になりましたか？私たちはそれについて聞きたいです！",
    shareBtn: "あなたの物語を教えてください"
  },
  blog: {
    pageTitle: "旅行ブログ",
    pageSubtitle: "モロッコでの冒険のための物語、ヒント、ガイド",
    sectionTitle: "最新の旅行記事",
    sectionIntro: "モロッコ旅行、地元文化、インサイダーのヒントに関する最新記事をお読みください",
    readMore: "続きを読む →",
    by: "投稿者",
    newsletterTitle: "ニュースレターを購読する",
    newsletterText: "最新の旅行のヒントや限定オファーをメールでお届けします",
    newsletterPlaceholder: "メールアドレスを入力",
    subscribe: "購読する"
  },
  contact: {
    pageTitle: "お問い合わせ",
    pageSubtitle: "VIPモロッコアドベンチャーを計画するためにチームにご連絡ください",
    getInTouch: "連絡を取る",
    getInTouchText: "私たちは喜んでお手伝いし、質問にお答えします。",
    address: "住所",
    phone: "電話",
    email: "メール",
    businessHours: "営業時間",
    businessHoursText: "月曜日 - 金曜日: 9:00 - 18:00\n土曜日: 10:00 - 16:00\n日曜日: 休み",
    followUs: "フォローする",
    formTitle: "メッセージを送信する",
    successMessage: "✓ ありがとうございます！すぐにご連絡いたします。",
    fullName: "氏名",
    emailAddress: "メールアドレス",
    phoneNumber: "電話番号",
    subject: "件名",
    selectSubject: "件名を選択してください",
    tourInquiry: "ツアーについてのお問い合わせ",
    bookingQuestion: "予約に関する質問",
    customPackage: "カスタムパッケージ",
    feedback: "フィードバック",
    other: "その他",
    message: "メッセージ",
    sendMessage: "メッセージを送信",
    mapTitle: "地図上で見つける",
    faqTitle: "よくある質問",
    faq1Q: "モロッコを訪れるのに最適な時期はいつですか？",
    faq1A: "春（4月〜5月）と秋（9月〜10月）が最高の天候です。",
    faq2Q: "モロッコを訪れるにはビザが必要ですか？",
    faq2A: "ビザの要件は国籍によって異なります。多くの国では最大90日間のビザなし入国が可能です。",
    faq3Q: "モロッコではどの通貨が使われていますか？",
    faq3A: "モロッコ・ディルハム（MAD）が公式通貨です。",
    faq4Q: "モロッコでは何語が話されていますか？",
    faq4A: "アラビア語とベルベル語が公用語です。フランス語も広く話されています。",
    faq5Q: "モロッコは観光客にとって安全ですか？",
    faq5A: "はい、一般的に安全です。私たちのガイドが安全で楽しい体験を保証します。",
    faq6Q: "ツアーパッケージをカスタマイズできますか？",
    faq6A: "もちろんです！お客様に合わせたパッケージを提供しています。"
  },
  about: {
    pageTitle: "MoroccoLovesYouについて",
    pageSubtitle: "モロッコの魅力を発見するための信頼できるパートナー",
    storyTitle: "私たちの物語",
    storyP1: "MoroccoLovesYouは、旅行者がモロッコの本物の美しさ、文化、ホスピタリティを体験できるようにするというシンプルな使命を持って設立されました。",
    storyP2: "私たちの創設者はモロッコに恋をし、この情熱を世界と共有したいと考えました。",
    missionTitle: "🎯 私たちの使命",
    missionText: "モロッコの豊かな文化遺産を示す卓越した旅行体験を提供すること。",
    visionTitle: "🌟 私たちのビジョン",
    visionText: "信頼性と本物であることで知られるモロッコを代表する観光会社になること。",
    whyTitle: "なぜMoroccoLovesYouを選ぶのですか？",
    expertTitle: "専門知識",
    expertText: "私たちのチームはモロッコに関する豊富な知識を持っています。",
    localTitle: "現地の繋がり",
    localText: "信頼できる現地のガイドと協力しています。",
    valueTitle: "最高の価値",
    valueText: "品質を妥協することなく競争力のある価格設定。",
    safetyTitle: "安全性とサポート",
    safetyText: "24時間年中無休のカスタマーサポートと旅行保険が含まれています。",
    sustainTitle: "持続可能な観光",
    sustainText: "地域社会を支援し、責任ある観光を実践しています。",
    bookingTitle: "簡単な予約",
    bookingText: "柔軟な支払いオプションを備えた簡単なオンライン予約プロセス。",
    teamTitle: "私たちのチーム",
    teamSubtitle: "MoroccoLovesYouの情熱的な人々をご紹介します",
    happyTravelers: "幸せな旅行者",
    yearsExp: "年の経験",
    destinationsCount: "目的地",
    satisfactionRate: "満足度"
  },
  footer: {
    description: "私たちと一緒にモロッコの魔法を発見してください。忘れられない冒険を体験してください。",
    quickLinks: "クイックリンク",
    more: "詳細",
    contactInfo: "連絡先情報",
    copyright: "© 2024 MoroccoLovesYou. 無断複写・転載を禁じます。"
  },
  starBanner: {
    ceoMessage: "CEOからのメッセージ",
    watchVideo: "動画を見る",
    readMessage: "＆メッセージを読む",
    getToKnow: "Ilanを",
    ilanPersonally: "個人的に知る"
  },
  tourMini: {
    days: "10日間",
    nights: "/ 9泊",
    title: "プレミアム モロッコ\nツアー",
    years: "2026 - 2027",
    departures: "毎月出発",
    allIncluded: "すべて込み\nフルボード",
    recommendations: "推奨事項",
    recCount: "500人以上の幸せな旅行者"
  },
  cityDetail: {
    notFound: "都市が見つかりません",
    backHome: "ホームに戻る",
    discoverSubtitle: "美しさと文化を発見する",
    planTrip: "私の旅行を計画する：",
    galleryOf: "ギャラリー：",
    bookExperience: "この体験を予約する",
    requestItinerary: "完全な旅程をリクエストする",
    readyToVisit: "訪問する準備はできましたか？",
    readyToVisitText: "この素晴らしい目的地への完璧な旅を計画させてください",
    planMyTrip: "旅行を計画する",
    talkExpert: "専門家に相談する"
  },
  transportation: {
    pageTitle: "VIP向け交通サービスとドライバー",
    pageSubtitle: "モロッコ全土でのラグジュアリー、快適さ、そして安全性",
    introTitle: "私たちの VIP 交通サービスとドライバー",
    introP1: "Morocco Loves Youでは、交通は単なる移動手段ではありません。",
    introP2: "それは体験の一部です。",
    introP3: "私たちはモロッコ全土で、プロのドライバー、温かいおもてなし、そして最初から最後までVIPサービスを提供し、清潔で快適な最新のエアコン完備の車両を提供しています。",
    introP4: "カップル、ご家族、ビジネス代表団、プライベートグループのいずれで旅行される場合でも、私たちはあなたの旅が安全でリラックスでき、忘れられないものになるよう努めます。",
    servicesTitle: "私たちの交通サービスには以下が含まれます",
    servicesList: [
      "最新の VIP バス",
      "豪華ミニバス",
      "プライベートカー",
      "砂漠探険用 4x4 ジープ",
      "VIP リムジン",
      "空港送迎サービス",
      "プロの多言語ドライバー",
      "快適なエアコン完備",
      "清潔で整理された車両",
      "一部の車両には冷蔵庫を完備",
      "テレビとエンターテイメントシステム",
      "旅の間の音楽",
      "安全でスムーズな運転",
      "モロッコ全土での 24 時間年中無休のサポート"
    ],
    driversTitle: "ドライバーの紹介",
    driversText1: "私たちのドライバーは Morocco Loves You ファミリーの一員です。",
    driversText2: "プロフェッショナルで、礼儀正しく、経験豊富で、常に笑顔でサポートする準備ができています。",
    driversText3: "多くのドライバーが複数の言語を話し、モロッコを深く知っています。これにより、お客様は旅の間中、快適で安全、そしてつながりを感じることができます。",
    safetyTitle: "安全性と快適さを第一に",
    safetyText1: "お客様の快適さと安全は私たちの最優先事項です。",
    safetyText2: "すべての車両は定期的にメンテナンス、清掃され、すべての旅行の前に慎重に準備されます。",
    safetyText3: "私たちは、信頼できるプロのドライバーと高品質の輸送パートナーのみと協力しています。",
    categories: {
      buses: "VIP バス",
      minibuses: "豪華ミニバス",
      cars: "プライベートカーと VIP 送迎",
      jeeps: "4x4 ジープと砂漠の交通",
      meetDrivers: "ドライバーの紹介",
      videos: "交通体験ビデオ"
    },
    videoGalleryTitle: "VIP 体験ビデオ",
    ctaTitle: "快適にモロッコを探索する準備はできましたか？",
    ctaSubtitle: "創業者兼 CEO の Allan と直接話す",
    whatsapp: "WhatsApp: +972546338757",
    moroccoLine: "モロッコ直通電話: +212 6 63 63 05 79"
  },
  jewishHeritage: {
    pageTitle: "モロッコ高級コーシャツアー",
    pageSubtitle: "本物のユダヤ遺産、100%コーシャ料理、上質なおもてなし、そして特別なモロッコ体験。",
    introTitle: "ラグジュアリーなユダヤ遺産体験",
    introHeading: "本物のユダヤ系モロッコを発見",
    introText: "モロッコに根づくユダヤ史を、上質で本格的な旅として体験してください。世界中のユダヤコミュニティに、遺産、つながり、快適さを重視したスムーズな旅を提供します。",
    introQuote: "「モロッコは寛容と共存の地であり、ユダヤ遺産が愛と敬意をもって守られています。」",
    experiencesTitle: "コーシャ体験に含まれるもの",
    experiencesList:     [
          "100%コーシャ料理とレストラン",
          "専属コーシャシェフ手配可能",
          "伝統的なモロッコ系ユダヤ料理",
          "4・5つ星の高級ホテル",
          "専用VIP交通サービス",
          "多言語対応のプロガイド",
          "ユダヤ遺産とシナゴーグツアー"
    ],
    expFood: "100%コーシャ料理",
    expRestaurant: "コーシャレストラン",
    expChef: "専属コーシャシェフ手配可能",
    expCuisine: "伝統的なモロッコ系ユダヤ料理",
    expHotels: "4・5つ星の高級ホテル",
    expDeluxeHotels: "デラックスホテルはリクエストに応じて手配可能",
    expTransport: "専用VIP交通サービス",
    expDrivers: "プロフェッショナルドライバー",
    expAC: "エアコン付き車両",
    expWifi: "一部車両にWiFi、TV、冷蔵庫完備",
    expGuides: "多言語対応のプロガイド",
    expStaff: "ヘブライ語 / 英語 / フランス語 / スペイン語 / ロシア語 / ドイツ語対応スタッフ",
    expHeritage: "ユダヤ遺産ツアー",
    expSynagogues: "歴史あるシナゴーグ",
    expCemeteries: "ユダヤ人墓地",
    expMuseums: "ユダヤ博物館",
    expSpiritual: "精神的・文化的体験",
    expDesert: "サハラ砂漠体験",
    expHammam: "モロッコ式ハマム体験",
    expAttractions: "モロッコ各地のユニークな観光地",
    expAssistance: "24時間年中無休のサポート",
    packagesTitle: "柔軟なコーシャ旅行パッケージ",
    packagesIntro: "お客様のニーズ、伝統、旅行スタイル、日程、ご希望に合わせてすべての旅をカスタマイズします。",
    package4_5: "4-5 Days",
    package7_8: "7-8 Days",
    package10_11: "10-11 Days",
    package13_14: "13-14 Days",
    package21: "21日間",
    packageTailor: "オーダーメイドのプライベートツアー",
    packagesQuote: "「お客様のニーズ、伝統、旅行スタイル、日程、ご希望に合わせてすべての旅をカスタマイズします。」",
    safetyTitle: "快適でプロフェッショナル、そして安全な旅",
    safetyQuote: "「私たちのツアーは、快適さ、運営、サービス品質、モロッコ全土での専門的な連携に細心の注意を払って実施されています。」",
    b2bTitle: "B2Bユダヤ旅行パートナーシップ",
    b2bText: "世界中のユダヤコミュニティ、シナゴーグ、ラビ、コーシャツアー運営会社と協力し、意味ある遺産の旅を作ります。",
    b2bPartnersList: "提携先: 世界中のユダヤコミュニティ、シナゴーグ、ラビ、ユダヤ団体、コーシャツアー運営会社、旅行代理店。",
    partnerBtn: "パートナーになる",
    galleryTitle: "コーシャ体験ギャラリー",
    videosTitle: "注目動画",
    ctaTitle: "旅を始める準備はできましたか？",
    msgAllan: "AllanにWhatsAppで連絡",
    callMorocco: "モロッコへ電話: +212 6 63 63 05 79",
    ceoContact: "WhatsAppでAllan Hatchuelと直接話す",
    exploreBtn: "コーシャ旅行を探す"
  },
  aria: {
    openMenu: "メニューを開く",
    closeMenu: "メニューを閉じる",
    whatsappSocial: "WhatsApp",
    kosherTravel: "モロッコのコーシャ旅行",
    logoAlt: "MoroccoLovesYouロゴ",
    kingAlt: "モロッコ国王",
    kosherOptionsAlt: "コーシャ対応オプション",
    jewishHeritageArchitecture: "ユダヤ遺産の建築",
    kosherMoroccanTable: "コーシャのモロッコ料理テーブル",
    luxuryHospitality: "ラグジュアリーなおもてなし",
    kosherExperience: "コーシャ体験",
    jewishHeritageMorocco: "モロッコのユダヤ遺産",
    kosherFoodMorocco: "モロッコのコーシャ料理",
    jewishHeritageExperience: "ユダヤ遺産体験"
  }
};

export default ja;
